@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.container {
    margin: 0 auto;
    max-width: 62.5rem;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        margin: 0 5%;
    }
}

.header {
    font-size: 3.75rem;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        font-size: 2rem;
    }
}

.pubDate {
    font-size: 2.25rem;
    font-weight: 700;
    margin: 20px 0 0;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        font-size: 1.5rem;
    }
}

.articleNav {
    text-align: center;
    margin: 40px 0;
}

.pressSectionLink {
    composes: button from "../../styles/buttons.module.scss";
}
